<agr-page-toolbar
  [pageTitle]="'varietyProperties.title' | translate"
  [hasPrimaryAction]="true"
  primaryActionIcon="add"
  [primaryActionText]="'varietyProperties.addVarietyProperty' | translate"
  (primaryAction)="createVarietyProperty()"
>
  <div class="container">
    <agr-notification-empty
      [isEmpty]="!dataAvailable"
      [emptyDescription]="'varietyProperties.varietyPropertiesEmpty' | translate"
      emptyActionIcon="clear"
    >
      <mat-table [dataSource]="dataSource" data-test="variety-property-table">
        <ng-container matColumnDef="ediCode">
          <mat-header-cell *matHeaderCellDef>{{
            'varietyProperties.ediCode' | translate
          }}</mat-header-cell>
          <mat-cell *matCellDef="let row">{{ row.ediCode }}</mat-cell>
        </ng-container>

        <ng-container matColumnDef="cropVarietyName">
          <mat-header-cell *matHeaderCellDef>{{
            'varietyProperties.cropVarietyName' | translate
          }}</mat-header-cell>
          <mat-cell *matCellDef="let row">{{ row.cropVarietyName }}</mat-cell>
        </ng-container>

        <ng-container matColumnDef="productionPurposeCategoryName">
          <mat-header-cell *matHeaderCellDef>{{
            'varietyProperties.productionPurposeCategoryName' | translate
          }}</mat-header-cell>
          <mat-cell *matCellDef="let row">{{ row.productionPurposeCategoryName }}</mat-cell>
        </ng-container>

        <ng-container matColumnDef="foliageMax">
          <mat-header-cell *matHeaderCellDef>{{
            'varietyProperties.foliageMax' | translate
          }}</mat-header-cell>
          <mat-cell *matCellDef="let row">{{ row.foliageMax }}</mat-cell>
        </ng-container>

        <ng-container matColumnDef="day50Percent">
          <mat-header-cell *matHeaderCellDef>{{
            'varietyProperties.day50Percent' | translate
          }}</mat-header-cell>
          <mat-cell *matCellDef="let row">{{ row.day50Percent }}</mat-cell>
        </ng-container>

        <ng-container matColumnDef="nEfficiency">
          <mat-header-cell *matHeaderCellDef>{{
            'varietyProperties.nEfficiency' | translate
          }}</mat-header-cell>
          <mat-cell *matCellDef="let row">{{ row.nEfficiency }}</mat-cell>
        </ng-container>

        <ng-container matColumnDef="nNorm">
          <mat-header-cell *matHeaderCellDef>{{
            'varietyProperties.nNorm' | translate
          }}</mat-header-cell>
          <mat-cell *matCellDef="let row">{{ row.nNorm }}</mat-cell>
        </ng-container>

        <ng-container matColumnDef="nMax">
          <mat-header-cell *matHeaderCellDef>{{
            'varietyProperties.nMax' | translate
          }}</mat-header-cell>
          <mat-cell *matCellDef="let row">{{ row.nMax }}</mat-cell>
        </ng-container>

        <ng-container matColumnDef="kMin">
          <mat-header-cell *matHeaderCellDef>{{
            'varietyProperties.kMin' | translate
          }}</mat-header-cell>
          <mat-cell *matCellDef="let row">{{ row.kMin }}</mat-cell>
        </ng-container>

        <ng-container matColumnDef="kMax">
          <mat-header-cell *matHeaderCellDef>{{
            'varietyProperties.kMax' | translate
          }}</mat-header-cell>
          <mat-cell *matCellDef="let row">{{ row.kMax }}</mat-cell>
        </ng-container>

        <ng-container matColumnDef="giftcorrection">
          <mat-header-cell *matHeaderCellDef>{{
            'varietyProperties.giftcorrection' | translate
          }}</mat-header-cell>
          <mat-cell *matCellDef="let row">{{ row.giftcorrection }}</mat-cell>
        </ng-container>

        <ng-container matColumnDef="plantHa">
          <mat-header-cell *matHeaderCellDef>{{
            'varietyProperties.plantHa' | translate
          }}</mat-header-cell>
          <mat-cell *matCellDef="let row">{{ row.plantHa }}</mat-cell>
        </ng-container>

        <ng-container matColumnDef="maturity">
          <mat-header-cell *matHeaderCellDef>{{
            'varietyProperties.maturity' | translate
          }}</mat-header-cell>
          <mat-cell *matCellDef="let row">{{ row.maturity }}</mat-cell>
        </ng-container>

        <ng-container matColumnDef="mgMin">
          <mat-header-cell *matHeaderCellDef>{{
            'varietyProperties.mgMin' | translate
          }}</mat-header-cell>
          <mat-cell *matCellDef="let row">{{ row.mgMin }}</mat-cell>
        </ng-container>

        <ng-container matColumnDef="mgMax">
          <mat-header-cell *matHeaderCellDef>{{
            'varietyProperties.mgMax' | translate
          }}</mat-header-cell>
          <mat-cell *matCellDef="let row">{{ row.mgMax }}</mat-cell>
        </ng-container>

        <ng-container matColumnDef="actions">
          <mat-header-cell *matHeaderCellDef class="flex__child flex__child-2"></mat-header-cell>
          <mat-cell *matCellDef="let row" class="flex--justify-end flex__child flex__child-2">
            <agr-responsive-actions
              [items]="varietyPropertyActions"
              [showLabels]="false"
              (action)="varietyPropertyAction($event, row.id)"
            ></agr-responsive-actions>
          </mat-cell>
        </ng-container>

        <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
        <mat-row
          *matRowDef="let row; columns: displayedColumns"
          data-test="variety-property-row"
        ></mat-row>
      </mat-table>
    </agr-notification-empty>
  </div>
</agr-page-toolbar>
